import { render } from "./InputTypes.vue?vue&type=template&id=a3897c64&scoped=true"
import script from "./InputTypes.vue?vue&type=script&lang=js"
export * from "./InputTypes.vue?vue&type=script&lang=js"

import "./InputTypes.vue?vue&type=style&index=0&id=a3897c64&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3897c64"]])

export default __exports__